import Vue from 'vue';
import Router from 'vue-router';
import Avatar from './components/steps/Avatar'
import Question from './components/steps/Question'
import DragDrop from './components/steps/DragDrop'
import TextRange from './components/steps/TextRange'
import Result from './components/Result'
import steps from './appdata/steps.js'

const components = { 'Question': Question, 'DragDrop': DragDrop, 'TextRange': TextRange }

import store from './common/Store.js'

function ifAvatar() {
  if (store.state.avatar != '') {
    return;
  } else {
    return { path: '/' }
  }
}

Vue.use(Router);
const myRoutes = [
        
  {
      path: '/',
      redirect: '/avatar',
  },
  {
    path: '/avatar',
    component: Avatar,
  },
  
];

// avatar is 0
let i;
steps.steps.map(function (step, key) {
  i = key + 1;

  myRoutes.push({
    name: 'step-' + i,
    path: '/'+i,
    component: components[step.type],
    beforeEnter: (to, from, next) => {
      next(ifAvatar());
    },
    meta: {
      stepKey : key
    }
  });
});
myRoutes.push({
  name: 'result',
  path: '/'+(i+1),
  component: Result,
});

const router = new Router({
  //mode: 'abstract',
    routes: myRoutes,
});

// reset focus
export default router;


// WEBPACK FOOTER //
// ./src/router.js